import FallbackViewer from './FallbackViewer'
import InstantMessagerEvent from './InstantMessagerEvent'
import KeyLoggerEvent from './KeyLoggerEvent'
import Keyword from './KeywordViewer'

const ByTypeRegister = {
  InstantMessagerEvent,
  KeyLoggerEvent,
  Keyword,
}

export function findComponent (n) {
  const { metaData } = n

  // other special cases
  // chat screen scraped
  if (metaData.type.indexOf('ScreenScraped') >= 0) {
    return InstantMessagerEvent
  }

  // find by type
  const byType = ByTypeRegister[metaData.type]
  //console.log(metaData.type)
  if (byType) {
    return byType
  }

  // just show the default card
  return FallbackViewer
}
